import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@servicetim/ui/components';
import { cn } from '@servicetim/ui/lib';
import type { ReactNode } from 'react';

export interface SectionProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** Card with a title row (and optional right-aligned actions) for a project configuration panel. */
export function Section({ title, description, actions, className, children }: SectionProps) {
  return (
    <Card className={cn('gap-4 py-5', className)}>
      <CardHeader className="flex flex-row items-start justify-between gap-3">
        <div className="space-y-1">
          <CardTitle>{title}</CardTitle>
          {description ? <CardDescription>{description}</CardDescription> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </CardHeader>
      <CardContent className="space-y-4">{children}</CardContent>
    </Card>
  );
}
